<template>
  <div class="cooperation_application">
    <div class="s_wrapper">
      <el-date-picker v-model="datetime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="handleSelectData" value-format="yyyy-MM-dd"></el-date-picker>
      <el-input class="s_input" v-model="applyCode" suffix-icon="el-icon-search" placeholder="搜索申请编号" clearable @change="onSearch"></el-input>
      <el-input class="s_input" v-model="contactMan" suffix-icon="el-icon-search" placeholder="请输入联系人" clearable @change="onSearch"></el-input>
    </div>

    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="applyCode" label="申请编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="申请时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactMan" label="联系人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactTel" label="联系电话"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactEmail" label="联系邮箱"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleShow(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      datetime: [],
      // startTime: '',
      // endTime: '',
      contactMan: "",
      applyCode: "",
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getSysUserList()
  },
  methods: {
    onSearch() {
      this.clearData()
      this.getSysUserList()
    },
    // 时间搜索
    handleSelectData(value) {
      this.datetime = value
      this.onSearch()
    },
    handleShow(row) {
      // 路由传参跳转
      this.$router.push({
        path: "/cooperationApplication/list/details",
        query: {
          id: row.id,
        },
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },

    getSysUserList() {
      let params = {
        applyCode: this.applyCode,
        contactMan: this.contactMan,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      // 时间区间
      if (this.datetime && this.datetime.length === 2) {
        params.startTime = this.datetime[0]
        params.endTime = this.datetime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }
      console.log(params)
      this.$axios
        .get(this.$api.selectCompanyApplyInfoList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getSysUserList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getSysUserList()
    },
  },
}
</script>

<style scoped lang="scss">
.cooperation_application {
}
</style>
